import React from 'react';
import { formatCurrency } from 'utils/currencyHelper';

export const AmountCell = ({ cell }) => {
  const { amount } = cell.original;
  
  if (!amount) return <span>-</span>;
  
  // Basarse en el signo del monto:
  // - Monto positivo = dinero que ENTRA (crédito) → mostrar con +
  // - Monto negativo = dinero que SALE (débito) → mostrar con -
  const isMoneyIn = amount.amount > 0;
  const formattedAmount = formatCurrency(Math.abs(amount.amount), amount.currency);
  
  const sign = isMoneyIn ? '+' : '-';
  const className = isMoneyIn ? 'amount-credit' : 'amount-debit';
  
  return (
    <span className={`amount-cell ${className}`}>
      {sign} {formattedAmount}
    </span>
  );
};

